export default {
  name: "NoResult",
  props: ["keyword"]
};